interface StackedMarkProps {
  size?: number;
  className?: string;
}

/*
 * The Stacked mark — three bars settling into a stack, the top one lit
 * amber: "now" sits on top of everything else. This exact geometry is
 * mirrored in app/icon.tsx, app/apple-icon.tsx and public/icons/*.svg;
 * change one, change all.
 */
export function StackedMark({ size = 28, className }: StackedMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden
      className={className}
    >
      <rect x="6" y="6" width="20" height="5" rx="2.5" fill="hsl(37 91% 55%)" />
      <rect x="6" y="14" width="15" height="5" rx="2.5" fill="currentColor" />
      <rect x="6" y="22" width="10" height="5" rx="2.5" fill="currentColor" opacity="0.45" />
    </svg>
  );
}
